'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import CustomConfigs from '~/constants/customConfigs';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import CommonFeatureBranch from '../CommonFeatureBranch';

function useMaybeReloadPage() {
  const searchParams = useSearchParams();
  const pathname = usePathname() ?? '';

  useEffect(() => {
    if (!searchParams) return;

    const featureBranch = searchParams.get(CustomConfigs.FeatureBranch);

    if (!featureBranch) return;

    const searchParamsString = searchParams.toString();
    const newSearchParams = new URLSearchParams(searchParamsString);
    newSearchParams.delete(CustomConfigs.FeatureBranch);

    const newUrl = newSearchParams.toString()
      ? `${pathname}?${newSearchParams.toString()}`
      : pathname;

    // Navigate to clean URL and reload - this triggers nginx routing with cookies set
    window.location.replace(newUrl);
  }, [searchParams, pathname]);
}

type OwnProps = {
  className?: string;
};

function FeatureBranch({ className }: OwnProps) {
  useMaybeReloadPage();

  return <CommonFeatureBranch className={className} />;
}

export default withErrorBoundary(FeatureBranch);
